<template>

<div>

    <v-navigation-drawer app clipped left hide-overlay
        class="nav-drawer" 
        @input="drawer = $event" 
        :value="showNav" 
        :mini-variant="mini && $vuetify.breakpoint.lgAndUp" 
        :permanent="$vuetify.breakpoint.lgAndUp" 
        :style="navStyle" 
        :dark="globalDarkMode" 
        :light="!globalDarkMode"
    >
        <scrollable-content>
            <v-toolbar v-if="$vuetify.breakpoint.lgAndUp" dense :color="topBarColorString" dark slot="header">

                <!-- <v-btn v-if="!mini" small @click="editable = !editable" icon>
                    <v-icon size="16">{{editable ? "mdi-lock-open-variant" : "mdi-lock" }}</v-icon>
                </v-btn> -->
                <v-spacer v-if="!mini" />
                <v-btn icon @click.stop="mini = !mini">
                    <v-icon>{{ mini ? "mdi-chevron-double-right" : "mdi-chevron-double-left"}}</v-icon>
                </v-btn>
                <v-btn icon @click="hide()" small v-if="$vuetify.breakpoint.mdAndDown">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

            <div style="padding:20px;" v-else>
                <logo/>
            </div>

            <!-- <div>
                <v-card color="transparent" tile flat>
                    <div v-for="(item, i) in this.nav" :key="`nav-default-items-${i}`" style="margin-right:1px;" >

                        <v-menu tile :nudge-right="childMenuNudgeRight">

                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-on="item.children.length > 0 ? on : null" :style="{borderLeft:`6px ${item.color} solid`}" style="padding:0px" :to="item.children.length == 0 ? item.route : null">
                                    <v-icon style="width:49px;height:49px;" size="28">{{item.icon}}</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title style="zoom:.9;">{{item.name}}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="item.children.length > 0">
                                        <v-btn v-on.stop="on" small icon><v-icon>mdi-dots-horizontal</v-icon></v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider />
                            </template>

                            <v-card width="100%">
                                <div v-for="(child, c) in item.children" :key="`nav-child-items-${c}`">
                                    <v-divider v-if="c > 0" />
                                    <router-link class="router-link" :to="child.route" style="text-decoration:none;display:flex;padding:10px 30px 10px 0px;">
                                        <v-icon style="width:49px;">{{child.icon}}</v-icon>
                                        {{child.name}}
                                    </router-link>
                                </div>
                            </v-card>

                        </v-menu>

                    </div>
                </v-card>

            </div> -->
            
   <v-card color="transparent" tile flat>
        <slot name="leftNavItems">
          <v-list nav dense class="my-tile padding-bottom title-font">
            <div v-for="(groupItem, j) in sidebarItems" :key="groupItem.link || groupItem.tileName || `sidebar-${j}`">
                
              <div v-if="groupItem.subtiles">
                <v-list-group
                  :value="groupItem.value"
                  
                  
                >
                  <template v-slot:activator>
                    <v-list-item-action class="mr-1 pl-1">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon size="28" class="material-symbols-outlined" v-bind="attrs" v-on="on" color="navy">
                            {{ groupItem.icon }}</v-icon
                          >
                        </template>
                        <span>{{ groupItem.tileName }}</span>
                      </v-tooltip>
                    </v-list-item-action>
                    <v-list-item-content class="title-font">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-title
                            class="title-font"
                           
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ groupItem.tileName }}
                          </v-list-item-title>
                        </template>
                        <span>{{ groupItem.tileName }}</span>
                        <!-- Tooltip content -->
                      </v-tooltip>
                    </v-list-item-content>
                  </template>
                  <v-list nav dense >
                    <div v-for="(item, i) in groupItem.subtiles" :key="item.defaultLink || item.subTileName || `${groupItem.tileName}-subtile-${i}`">
                      <div v-if="item.applicationLinks">
                        <v-list-group :value="groupItem.value" >
                          <template v-slot:activator>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-list-item-title v-bind="attrs" v-on="on">
                                  <v-icon small  >{{
                                    item.icon
                                    
                                  }}</v-icon>
                                  <span
                                   
                                    
                                  >
                                    {{ item.subTileName }}
                                  </span>
                                </v-list-item-title>
                              </template>
                              <span>
                                {{ item.subTileName }}
                              </span>
                            </v-tooltip>
                          </template>
                          <div
                            v-for="(app, i) in item.applicationLinks"
                            :key="app.link || app.name || `app-${i}`"
                          >
                            <v-list-item
                              v-if="app.link.indexOf('http') === -1"
                              link
                              :to="app.link"
                            >
                              <v-list-item-action>
                                <v-tooltip right v-if="drawer">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="navy"
                                      >{{ app.icon }}</v-icon
                                    >
                                  </template>
                                  <span > {{ app.appName }}</span>
                                </v-tooltip>
                                <div v-if="!drawer">
                                  <v-icon
                                    small
                                    style="margin-left: 10px"
                                   color="navy"
                                    >{{ app.icon }}</v-icon
                                  >
                                </div>
                              </v-list-item-action>
                              <v-list-item-content >
                                <v-list-item-title>{{
                                  app.appName
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-list-group>
                      </div>
 
                      <div v-else>
                        <v-list-item
                          v-if="item.isUrl"
                          :href="item.url"
                          link
                          target="_blank"
                        >
                          <v-list-item-action>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="navy"
                                  >{{ item.icon }}</v-icon
                                >
                              </template>
                              <span >
                                {{ item.subTileName }}</span>
                            </v-tooltip>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-list-item-title v-bind="attrs" v-on="on">
                                  <span >{{
                                    item.subTileName
                                  }}</span></v-list-item-title
                                >
                              </template>
                              <span >{{ item.subTileName }}</span>
                            </v-tooltip>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.separteReport"
                          :to="item.defaultLink"
                          link
                        >
                          <v-list-item-action>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="navy"
                                  >{{ item.icon }}</v-icon
                                >
                              </template>
                              <span > {{ item.subTileName }}</span>
                            </v-tooltip>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-list-item-title v-bind="attrs" v-on="on">
                                  <span class=" short-font">{{
                                    item.subTileName &&
                                    item.subTileName.length > 35
                                      ? item.subTileName.substring(0, 30) +
                                        "..."
                                      : item.subTileName
                                  }}</span></v-list-item-title
                                >
                              </template>
                              <span color="navy" >{{ item.subTileName }}</span>
                            </v-tooltip>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    </div>
                  </v-list>
                </v-list-group>
              </div>
              <div v-else>
                <v-list-item :to="groupItem.link" link active="test">
                  <v-list-item-action class="mr-1 pl-1">
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="28" class="material-symbols-outlined" v-bind="attrs" v-on="on" color="navy" >
                          {{ groupItem.icon }}</v-icon
                        >
                      </template>
                      <span >{{ groupItem.tileName }}</span>
                    </v-tooltip>
                    <div v-if="!drawer"></div>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item-title
                          v-bind="attrs"
                          v-on="on"
                         color="navy"
                        >
                          <span  color="navy">{{
                            groupItem.tileName
                          }}</span></v-list-item-title
                        >
                      </template>
                      <span color="navy">{{ groupItem.tileName }}</span>
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </v-list>
        </slot>
      </v-card>

            <!-- <v-footer bottom style="padding: 0px" color="transparent" fixed>
                <v-divider />
                <v-list width="100%" dense>
                    <v-list-item :to="item.route" v-for="(item, i) in bottomLinks" :key="item.route || `bottom-${i}`" disabled>
                        <v-list-item-icon>
                            <v-icon size="22">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content v-if="!mini">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-footer> -->
        </scrollable-content>
    </v-navigation-drawer>
</div>
</template>

<script>
import nav from "@/_config/navigation.js";
import appSettings from "@/_mixins/app-settings-mixin";
import uiView from "@/_mixins/ui-view-mixin";
import navAppItem from "@/_components/layouts/nav-app-item";
import userSettings from "@/_mixins/user-settings-mixin";
import logo from "@/_components/layouts/logo";
import { sidebarMenu }  from "../../apps/psct/routes/sidebar";
import requestsMixin from "../../apps/psct/mixins/requests-mixin";

export default {
    name: "NavigationMain",
    props: {
        value: {
            type: Boolean,
            default: false
        },
    },
   async mounted() {
        this.mini = !this.globalNavPinnedOpen;
        this.globalLoadedAnimations = this.globalPinnedApps.slice(0);
        
 // await this.getUser();

    },
    mixins: [userSettings, appSettings, uiView, requestsMixin],

    watch: {
        value(newVal) {
            this.drawer = newVal;
        },
        drawer(newVal) {
            this.$emit("input", newVal);
        },
        mini(newValue) {
            this.globalNavPinnedOpen = !newValue;
        },
    },
    components: {
        navAppItem,
        userSettings,
        logo,
    },
    computed: {
        childMenuNudgeRight()
        {
            return this.mini
                ? 56
                : 256;
        },
        route() {
            return this.$route;
        },
        newAppItem() {
            return {
                name: "Add an app",
                route: "/my/newapp",
                icon: "mdi-plus",
                description: "",
            };
        },

        navStyle() {
            var ret = {};
            if (this.$vuetify.breakpoint.lgAndUp) {
                var color = this.globalNavBackgroundColor
                //console.log(color);
                ret["background-color"] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
            }
            return ret;
        },
        bottomLinks() {
            return [{
                    text: "Favorites",
                    icon: "mdi-star",
                    route: "/personal/favorites"
                },
                {
                    text: "History",
                    icon: "mdi-history",
                    route: "/personal/history"
                },
            ];
        },
        showNav() {
            return this.value || this.$vuetify.breakpoint.lgAndUp;
        },
        width() {
            var sizes = {
                xs: "100%",
                sm: 400,
                md: 400,
                lg: 350,
                xl: 350,
            };
            return sizes[this.$vuetify.breakpoint.name];
        },
        sidebarItems() {
            if (!this.$store.getters.getUserRole) {
              return []; // Return empty array if no role is set
            }
            return sidebarMenu[this.$store.getters.getUserRole] || []; // Get the menu items for the current role
        }
    },
    data() {
        return {
            mini: true,
            drawer: true,
            nav: nav,
            editable: false,
            userRole: localStorage.getItem('userRole'), 
            // menuItems:  [
            //     {
            //         icon: "mdi-home ",
            //         tileName: "Home",
            //         link: "/psct/region",
            //     },
            //     {
            //         icon: "mdi-artstation",
            //         tileName: "Category",
            //         link: "/psct/category",
            //     },
            //     {
            //         icon: "mdi-vector-arrange-above",
            //         tileName: "Welcome",
            //         link: "/psct/welcome",
            //     },
            //     {
            //         icon: "mdi-frequently-asked-questions",
            //         tileName: "FAQ",
            //         link: "/psct/faq",
            //     },
            //     {
            //         icon: "mdi-account-box-multiple-outline",
            //         tileName: "Admin",
            //         subtiles: [
                       
            //             {
            //                 icon: "mdi-animation-outline",
            //                 subTileName: "Buying Group",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/buying-group",
            //                 isUrl: false,

            //             },
            //             {
            //                 icon: "mdi-notebook-multiple",
            //                 subTileName: "Region And Plants",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/regionandplants",
            //                 isUrl: false,

            //             },
                        
                        
            //             {
            //                 icon: "mdi-bell-ring",
            //                 subTileName: "Updates To Strategy",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/updatestostrategy",
            //                 isUrl: false,

            //             },
                       
            //             {
            //                 icon: "mdi-link-box",
            //                 subTileName: "Quick Links",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/quicklinks",
            //                 isUrl: false,

            //             },
            //         ]
            //     },
            //     {
            //         icon: "mdi-content-save-all",
            //         tileName: "CM Form Submission",
            //         subtiles: [
            //             {
            //                 icon: "mdi-view-grid-plus",
            //                 subTileName: "Category Submission",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/categorysubmission",
            //                 isUrl: false,

            //             },
            //             {
            //                 icon: "mdi-content-save-settings",
            //                 subTileName: "Commodity Submission",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/commoditysubmission",
            //                 isUrl: false,

            //             },
            //             {
            //                 icon: "mdi-wallet-plus",
            //                 subTileName: "Segment Submission",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/segmentsubmission",
            //                 isUrl: false,

            //             },
            //         ]
            //     },
            //     {
            //         icon: "mdi-content-save-all",
            //         tileName: "Form Requests",
            //         subtiles: [
            //             {
            //                 icon: "mdi-view-grid-plus",
            //                 subTileName: "Category Requests",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/categoryrequests",
            //                 isUrl: false,

            //             },
            //             {
            //                 icon: "mdi-content-save-settings",
            //                 subTileName: "Commodity Requests",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/commodityrequests",
            //                 isUrl: false,

            //             },
            //             {
            //                 icon: "mdi-wallet-plus",
            //                 subTileName: "Segment Requests",
            //                 appFolderName: "",
            //                 defaultLink: "/psct/segmentrequests",
            //                 isUrl: false,

            //             },
            //         ]
            //     },
            //   ],

        };
    },
    methods: {
        hide() {
            this.drawer = false;
        },
        handleAppRemove(app) {
            var index = this.globalPinnedApps.indexOf(app.id);
            this.globalPinnedApps.splice(index, 1);
        },
        onDrop(dropResult) {
            var item = this.globalPinnedApps.splice(dropResult.removedIndex, 1);
            this.globalPinnedApps.splice(dropResult.addedIndex, 0, item[0]);
        },
    },
};
</script>

<style lang="scss">
 .v-list--nav .v-list-item {
    padding: 0 !important;
}
.nav-drawer {
    top: 0px !important;
    height: 100vh !important;
    max-height: 100vh !important;
}
.child-nodes {
    padding: 0px 0px;
    background-color: rgba(0, 0, 0, .25);
}
.router-link,
.router-link * {
    color: white;
    font-family: "Roboto Condensed";
    transition: all .1s ease;
}
.router-link-active {
    font-size: 1.1em;
    font-weight: bold;
    opacity: 1;

}
.router-link {
    margin-left: 0px;
    opacity: .8;

    // i {
    //     visibility: hidden;
    // }

}

.my-tile .v-list {
  padding: 0;
}
::v-deep .v-list-item {
  padding: 0;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px;
  padding-left: 6px;
}

.router-link.router-link-active {
    opacity: 1;

    i {
        visibility: visible;
    }
}
</style>
